import { Component, Input, OnInit } from '@angular/core';
import { ApiError } from 'app/core';
import { PeriodicidadeCompraApi } from 'app/domains/environment/periodicidade-compra/api/periodicidade-compra.api';
import { IPeriodicidadeCompraSummary } from 'app/domains/environment/periodicidade-compra/interfaces/periodicidade-compra-list-request.interface';
import { ToastService } from '../toast/services/toast.service';

import { IPeriodicidadeCompraFilter } from 'app/domains/environment/periodicidade-compra/interfaces/periodicidade-compra-filter.interface';

@Component({
  selector: 'sgt-tabela-vigencia-carteira-cliente',
  templateUrl: './tabela-vigencia-carteira-cliente.component.html',
  styleUrls: ['./tabela-vigencia-carteira-cliente.component.scss'],
})
export class TabelaVigenciaCarteiraClienteComponent implements OnInit {
  filter: IPeriodicidadeCompraFilter = {
    situacoes: 1,
    sort: 'cliente_carteira_quantidade_meses_preinativar',
    sortDir: 'asc',
  };

  public periodicidadesCompras: IPeriodicidadeCompraSummary[] = [];
  public lineInFocus: number | null = null;

  @Input()
  set idPeriodicidadeCompraInFocus(value: number | null | undefined) {
    if (value) {
      this.lineInFocus = value;
    }
  }

  constructor(
    private periodicidadeCompraApi: PeriodicidadeCompraApi,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.loadPeriodicidadesCompras();
  }

  private loadPeriodicidadesCompras() {
    this.periodicidadeCompraApi
      .fetchPeriodicidadesComprasList(this.filter)
      .pipe()
      .subscribe({
        next: (response) => {
          this.periodicidadesCompras = response.data;
        },
        error: (err: ApiError) => {
          this.toastService.error(err.message, {
            title: err.cause || 'Aconteceu algo inesperado.',
            duration: 5000,
          });
        },
      });
  }
}
